import { createComponent } from '@lit-labs/react';
import React from 'react';

export class BaseButtonDS extends HTMLElement {
  clickable?: boolean;
  disabled?: boolean | null;
  class?: string | null;
  secondary?: boolean;
  constructor() {
    super();
  }
}

export const BaseButton = createComponent(React, 'base-button', BaseButtonDS, {});
